/**
 * O disco de um contacto: matiz e iniciais.
 *
 * Portado de ai-agent-widget app/src/ui/avatar.tsx (pickAvatarPalette e
 * getInitial), com o mesmo hash e a mesma lista de matizes, para que o mesmo
 * nome caia no mesmo matiz nos dois lados. O que MUDA aqui e o que fica em CSS:
 * o widget escreve `hsl(...)` inline porque so tem um tema, e este ecra tem
 * dois, portanto daqui sai so o numero do matiz e a saturacao e a luminosidade
 * vem dos tokens --color-avatar-bg / -fg (ver .contact-avatar em index.css).
 *
 * Puro: sem React, sem rede, a mesma entrada da sempre a mesma saida.
 */

// Os oito matizes do widget, pela mesma ordem. Sao poucos e escolhidos: uma
// roda de 360 graus daria vizinhos indistinguiveis numa lista de 50 linhas.
const HUES = [220, 145, 35, 0, 280, 195, 330, 265];

/**
 * Matiz estavel para uma semente. A semente e o NOME quando o contacto tem um
 * (dois contactos com o mesmo nome partilham o disco, o que esta certo) e o id
 * do contacto quando nao tem. Para os 96 em 97 contactos anonimos da producao
 * o id e a unica identidade que existe, e e real: as doze conversas do mesmo
 * visitante anonimo ficam todas com o mesmo disco, na lista e no historico.
 *
 * @param {string|null|undefined} seed
 * @returns {number} um dos oito matizes
 */
export const avatarHue = (seed) => {
  const text = typeof seed === "string" ? seed : "";
  let hash = 0;
  for (let i = 0; i < text.length; i += 1) {
    hash = (hash * 31 + text.charCodeAt(i)) | 0;
  }
  return HUES[Math.abs(hash) % HUES.length];
};

/**
 * Uma ou duas iniciais de um nome. Duas quando o nome tem mais do que uma
 * palavra, e sao a primeira e a ULTIMA, que e o par que as pessoas reconhecem.
 *
 * codePointAt e nao charAt: um nome comecado por emoji partia-se a meio do par
 * substituto e desenhava um losango. Mesma razao do getInitial do widget.
 *
 * @param {string|null|undefined} name
 * @returns {string} vazio quando nao ha nome, e ai quem chama desenha um glifo
 */
export const initialsOf = (name) => {
  const words = (typeof name === "string" ? name : "").trim().split(/\s+/).filter(Boolean);
  if (!words.length) return "";
  const first = words[0].codePointAt(0);
  const head = first ? String.fromCodePoint(first) : "";
  if (words.length === 1) return head.toUpperCase();
  const last = words[words.length - 1].codePointAt(0);
  return (head + (last ? String.fromCodePoint(last) : "")).toUpperCase();
};
